import { render, staticRenderFns } from "./EnroachmentTypeList.vue?vue&type=template&id=5abaaab9"
import script from "./EnroachmentTypeList.vue?vue&type=script&lang=js"
export * from "./EnroachmentTypeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports